export default "__VITE_ASSET__BLBsVJB0__"